/*
  Desktop mega menu: open on hover, click the label to go to its page (adam, 12 Oct 2026, option A).
  Why: Clarity, desktop homepage 9–12 Oct: DRESSES was the most-clicked item (84) and 32 of those shoppers then
  clicked "All Dresses", i.e. two clicks to reach one page.
  - Mouse screens only (hover-capable, fine pointer, 990px+). iPads, phones and touch keep tap-to-open.
  - Hover opens after 150ms (no flashing when the mouse crosses the header); leaving closes after 300ms, so
    shoppers can move down into the dropdown. Moving to another label switches straight across.
  - Clicking a label goes to the page set for it in Online Store > Navigation (data-lp-href on the summary).
    OUR VALUES has no page of its own: a click just keeps its dropdown open (adam, 12 Oct).
  - Keyboard (Enter / Space) still opens and closes the dropdown as before.
*/
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var OPEN_DELAY = 150, CLOSE_DELAY = 300;
  var timers = new WeakMap();

  function setOpen(details, open) {
    if (details.open === open) return;
    details.open = open; // fires "toggle", so the theme's header-menu behaviour (backdrop, sticky header) still runs
    var s = details.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function all() { return Array.prototype.slice.call(document.querySelectorAll('header-menu details.mega-menu')); }
  function clear(d) { var t = timers.get(d); if (t) clearTimeout(t); timers.delete(d); }

  function bind(details) {
    if (details.getAttribute('data-lp-hover')) return;
    details.setAttribute('data-lp-hover', '1');
    var item = details.closest('li') || details;
    item.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clear(details);
      var anyOpen = all().some(function (d) { return d !== details && d.open; });
      var openNow = function () { all().forEach(function (d) { if (d !== details) { clear(d); setOpen(d, false); } }); setOpen(details, true); };
      if (anyOpen) openNow(); else timers.set(details, setTimeout(openNow, OPEN_DELAY));
    });
    item.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      clear(details);
      timers.set(details, setTimeout(function () { setOpen(details, false); }, CLOSE_DELAY));
    });
    var summary = details.querySelector('summary');
    if (summary) summary.addEventListener('click', function (e) {
      // e.detail is 0 for keyboard-triggered clicks: keep the normal open/close for keyboard users.
      if (!mq.matches || e.detail === 0) return;
      var href = summary.getAttribute('data-lp-href');
      e.preventDefault();
      if (!href) { clear(details); setOpen(details, true); return; } // e.g. OUR VALUES: a click keeps the hover-opened dropdown open
      if (e.metaKey || e.ctrlKey) window.open(href, '_blank'); else window.location.href = href;
    });
  }

  function init() { all().forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // The header can be re-rendered in the theme editor: bind any new menus.
  document.addEventListener('shopify:section:load', init);
})();
